var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayArrow24PxRounded = function SvgPlayArrow24PxRounded(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_arrow_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/av/play_arrow_24px",
    d: "M6.92749 6.82001V17.18C6.92749 17.97 7.79749 18.45 8.46749 18.02L16.6075 12.84C17.2275 12.45 17.2275 11.55 16.6075 11.15L8.46749 5.98001C7.79749 5.55001 6.92749 6.03001 6.92749 6.82001Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayArrow24PxRounded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "play_arrow_24px_rounded.ed03a166cfb1bb283909bcecbf6b7830.svg";